import { useCallback, useMemo, useState } from 'react';
import I18n from 'I18n';
import { AccessLevelContextProvider } from 'customer-data-properties/accessLevel/AccessLevelContext';
import { UNINITIATED } from 'call-widget-addon/calling-appeals/constants/portalSuspension';
import { POPOVER } from '../../constants/CommunicatorConstants';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { setCommunicatorTriggerLocation } from 'customer-data-communicator/data/communicator/actions/CommunicatorActions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { PageActions } from 'customer-data-communicator/data/communicator/actions/CommunicatorPageActions';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import { logPageAction } from 'customer-data-communicator/data/communicator/utils/eventLogger';
import CommunicatorLogger from 'customer-data-tracking/loggers/CommunicatorLogger';
import withCallingAccess from 'call-widget-addon/calling-appeals/hoc/withCallingAccess';
import { getAsyncAccountVerificationAppealState, getAsyncAccountVerificationCanAppeal, getShouldBlockCalling } from 'call-widget-addon/calling-appeals/operators/callingAccessGetters';
import useCallNumbersPopover from 'call-widget-addon/useCallNumbersPopover';
import { CALL } from 'crm-activity-creator-data/interaction/InteractionTypes';
import PopoverActivityButton from '../PopoverActivityButton';
import { useCreateActivityPermissions } from 'crm-activity-creator-data/permission/CreateActivityPermissionsContext';
import 'customer-data-communicator/data/communicator/actions/CommunicatorActions';
import { hideCommunicator
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
} from 'customer-data-communicator/data/communicator/actions/CommunicatorActions';
import { jsx as _jsx } from "react/jsx-runtime";
function CreateCallButton({
  buttonSize,
  callingAccess,
  interactionName,
  isOverflow = false,
  objectTypeId,
  onClickActionComplete,
  objectId,
  useCallingWidget
}) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const {
    currentUserCanCommunicate
  } = useCreateActivityPermissions();
  const tooltip = !currentUserCanCommunicate ? I18n.text('createActivityButtons.tooltip.disabled') : undefined;
  const source = useMemo(() => {
    return isOverflow ? 'overflow button' : 'activity button';
  }, [isOverflow]);
  const handlePopoverToggle = targetState => {
    setIsPopoverOpen(targetState);
  };

  // handle any calling popover before rendering calling widget
  const handleButtonClick = useCallback(() => {
    setIsPopoverOpen(prevIsPopoverOpen => !prevIsPopoverOpen);
    onClickActionComplete({
      targetState: !isPopoverOpen
    });
  }, [isPopoverOpen, onClickActionComplete]);
  const shouldCloseOnOutsideClick = useMemo(() => {
    const shouldBlock = getShouldBlockCalling(callingAccess);
    const canAppeal = getAsyncAccountVerificationCanAppeal(callingAccess);
    const vettingAppealState = getAsyncAccountVerificationAppealState(callingAccess);
    const alreadyAppealed = vettingAppealState !== null && vettingAppealState !== UNINITIATED;
    /**
     * We disable closeOnOutsideClick if we might be rendering the "appeal"
     * modal. Otherwise, allow closeOnOutsideClick
     */
    return !shouldBlock || !canAppeal || alreadyAppealed;
  }, [callingAccess]);
  const openCallCommunicator = useCallback((type, triggerLocation) => {
    setCommunicatorTriggerLocation({
      triggerLocation
    });
    logPageAction({
      key: PageActions.COMMUNICATOR_TRIGGER_LOCATION,
      tags: {
        location: triggerLocation
      }
    });
    setIsPopoverOpen(false);
    onClickActionComplete({
      targetState: false
    });
    CommunicatorLogger.log('communicatorInteraction', {
      action: 'open communicator',
      activity: type,
      channel: 'outbound call',
      source
    });
  }, [onClickActionComplete, source]);
  const sendCloseMessage = useSendCrmMessageTopic(TOPIC_NAMES.CLOSE_ACTIVITY_CREATOR);
  const closeInteractionWindow = useCallback(() => {
    sendCloseMessage({});
  }, [sendCloseMessage]);
  const handleCallButtonClick = useCallback(async () => {
    // The other widgets use the AC interaction window which will close any existing open windows when opened.
    //   Call uses the Call communicator, so we have to manually close any open windows.
    closeInteractionWindow();
    // If the old communicator is open instead, we have to close that. This has to be waited on due to a timing issue with third party custom calling objects in
    //   the Call communicator.
    await hideCommunicator();
    if (!useCallingWidget) {
      setIsPopoverOpen(false);
    }
    return useCallingWidget ? openCallCommunicator(CALL, POPOVER) : null;
  }, [closeInteractionWindow, openCallCommunicator, useCallingWidget]);
  const [renderedCallNumbersPopover] = useCallNumbersPopover({
    subjectId: objectId,
    objectTypeId,
    onCallButtonClick: handleCallButtonClick,
    shouldFetch: isPopoverOpen
  });
  return /*#__PURE__*/_jsx(AccessLevelContextProvider, {
    children: /*#__PURE__*/_jsx(PopoverActivityButton, {
      buttonProps: {
        onClick: handleButtonClick
      },
      buttonSize: buttonSize,
      dataTestId: "create-engagement-call-button",
      disabled: !currentUserCanCommunicate,
      interactionName: interactionName,
      isOverflow: isOverflow,
      onboardingSelector: "create-engagement-call",
      seleniumSelector: "create-engagement-call-button",
      objectTypeId: objectTypeId,
      objectId: objectId,
      closeOnOutsideClick: shouldCloseOnOutsideClick || !!isOverflow,
      content: renderedCallNumbersPopover,
      onPopoverToggle: handlePopoverToggle,
      open: isPopoverOpen,
      showCarrot: true,
      tooltipMessage: tooltip
    })
  });
}
export default withCallingAccess(CreateCallButton);

// for testing purposes
export { CreateCallButton as WrappedComponent };